var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { submitFormData } from "./api";
import { fetchAndStoreIpAddress } from "./ipService";
import { checkFieldVisible, getFieldConfig, getHeardAboutUsSource } from "./dfUtils";
import { path, removeFromStorage, safeLocalStorageGetItem, safeLocalStorageSetItem, readUrlParam, isGuid, isMsclkidCapturePath } from "./helperLib";
import { refinanceTypes, LanguageType } from "./interfaces";
import { isMobile, browserName, deviceType } from "react-device-detect";
import { Campaign } from "../configs/defaultValues";
import ReactGA from 'react-ga4';
var NAFSEOSc = { purchase: "10527817", refinance: "10527830" };
function oneTrustGaEnabled() {
    if (typeof window === "undefined")
        return false;
    var otGroups = window.OnetrustActiveGroups || "";
    return otGroups.includes("C0002");
}
export var createSubmitHandler = function (_a) {
    var flow = _a.flow, dispatch = _a.dispatch, setSubmitting = _a.setSubmitting, checkPage = _a.checkPage, submitting = _a.submitting, needsSpanishSpeakingLO = _a.needsSpanishSpeakingLO;
    var sendGa = function (category, action, label) {
        var _a, _b;
        oneTrustGaEnabled() &&
            ReactGA.event({
                category: category,
                action: action,
                label: label || "Step ".concat(flow.currentStep, " - ").concat(((_b = (_a = flow.config.pageCollection) === null || _a === void 0 ? void 0 : _a[flow.currentStep]) === null || _b === void 0 ? void 0 : _b.title) || '')
            });
    };
    return function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var valid, existingIp, ipErr_1, leadBody, formType, _a, data, status_1, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    e.preventDefault();
                    if (submitting)
                        return [2 /*return*/];
                    sendGa('Form', 'Submit Button Clicked');
                    // Trigger blur events on all form elements
                    document
                        .querySelectorAll("input, textarea, select")
                        .forEach(function (el) {
                        var blurEvent = new FocusEvent("blur", { bubbles: true });
                        el.dispatchEvent(blurEvent);
                    });
                    // Mark invalid fields as touched
                    Object.keys(flow.formData).forEach(function (fieldId) {
                        var _a;
                        var field = flow.formData[fieldId];
                        var fieldConfig = field === null || field === void 0 ? void 0 : field.config;
                        if (!fieldConfig)
                            return;
                        var visible = checkFieldVisible(fieldConfig);
                        if (visible && !(field === null || field === void 0 ? void 0 : field.isValid)) {
                            dispatch({
                                type: "UpdateFormData",
                                formData: (_a = {},
                                    _a[fieldId] = __assign(__assign({}, field), { touched: true }),
                                    _a),
                            });
                        }
                    });
                    valid = checkPage().valid;
                    if (!valid) {
                        checkPage();
                        return [2 /*return*/];
                    }
                    setSubmitting(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    existingIp = safeLocalStorageGetItem("ipAddress");
                    if (!!existingIp) return [3 /*break*/, 3];
                    return [4 /*yield*/, fetchAndStoreIpAddress()];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    ipErr_1 = _b.sent();
                    console.debug("Failed to fetch IP address at submit time:", ipErr_1);
                    return [3 /*break*/, 5];
                case 5:
                    formType = 'dynamic-form-unknown';
                    _b.label = 6;
                case 6:
                    _b.trys.push([6, 8, , 9]);
                    leadBody = buildLeadBody(flow, needsSpanishSpeakingLO);
                    formType = "dynamic-form-".concat(flow.config.templateType || 'unknown');
                    return [4 /*yield*/, submitFormData(leadBody)];
                case 7:
                    _a = _b.sent(), data = _a[0], status_1 = _a[1];
                    if (status_1 >= 400) {
                        console.error("Error submitting form: HTTP ".concat(status_1));
                        setSubmitting(false);
                        return [2 /*return*/];
                    }
                    handleSuccessfulSubmission(data, leadBody);
                    dispatch({ type: "Submit" });
                    return [3 /*break*/, 9];
                case 8:
                    error_1 = _b.sent();
                    console.error('Error during form submission:', error_1);
                    setSubmitting(false);
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); };
};
/** US-533873: only send HasAgent when borrower explicitly answered Yes/No on the form. */
function applyHasAgentToLeadBody(leadBody, value) {
    var normalized = value === null || value === void 0 ? void 0 : value.toString().trim().toLowerCase();
    if (normalized === "yes") {
        leadBody.HasAgent = true;
    }
    else if (normalized === "no") {
        leadBody.HasAgent = false;
    }
}
function buildLeadBody(flow, needsSpanishSpeakingLO) {
    var _a, _b, _c;
    var leadBody = {};
    var hauAnswerOptions = {};
    //fitler only visible fields
    var visibleFields = Object.keys(flow.formData).filter(function (fieldId) {
        var config = getFieldConfig(fieldId);
        return checkFieldVisible(config);
    });
    visibleFields.forEach(function (key) {
        var field = flow.formData[key];
        var value = field.fieldValue;
        if (value == null)
            return;
        //keep intentional _P/_R suffixes for notes field 
        key = key.replace(/^\d+_/, "") || key;
        //Lead.LoanAmt (no suffix on model)
        if (key === "loanAmt_P" || key === "loanAmt_R") {
            key = "loanAmt";
        }
        if (key === "HearAboutUs") {
            hauAnswerOptions = field.config.answerOptions || {};
        }
        if (key === "loanPurpose") {
            leadBody["LoanPurpose"] = refinanceTypes.includes(value.toLowerCase()) ? "Refinance" : "Purchase";
            return;
        }
        if (key === "hasAgent" || key === "HasAgent") {
            applyHasAgentToLeadBody(leadBody, value);
            return;
        }
        if (key === "loName") {
            leadBody["loName"] = safeLocalStorageGetItem("AgentName");
            return;
        }
        if (field.config.inputType === "currency" || field.config.inputType === "downPayment") {
            var cleanVal = value.toString().replace(/[$%,]/g, "").trim();
            var num = parseFloat(cleanVal);
            leadBody[key] = !isNaN(num) ? num.toString() : value;
            return;
        }
        leadBody[key] = value;
    });
    if (leadBody["LoanPurpose"] === "Refinance" && !leadBody["cashOutAmt"]) {
        leadBody["cashOutAmt"] = parseFloat("0").toString();
    }
    if (leadBody.propertyAddress) {
        Object.assign(leadBody, parsePropertyAddress(leadBody));
    }
    if (leadBody.HearAboutUs != null) {
        var heardAboutUsName = getHeardAboutUsSource(leadBody.LoanPurpose);
        var heardAboutSelected = hauAnswerOptions.find(function (item) { return item.value === leadBody.HearAboutUs; });
        if (heardAboutSelected != null) {
            var trumping = heardAboutSelected["HearAboutUsTrumping"];
            if (heardAboutUsName.substring(0, 3) === 'SEO') {
                leadBody.SourceCode = trumping ? heardAboutSelected[heardAboutUsName] || heardAboutSelected[leadBody.LoanPurpose.toLowerCase()]
                    : NAFSEOSc[leadBody.LoanPurpose.toLowerCase()];
            }
            else {
                leadBody.SourceCode = heardAboutSelected[heardAboutUsName]
                    || heardAboutSelected[leadBody.LoanPurpose.toLowerCase()];
            }
            leadBody.HearAboutUsTrumping = trumping;
        }
    }
    if (needsSpanishSpeakingLO) {
        // leadBody["NeedsSpanishSpeakingLO"] = true;
        leadBody["Language"] = LanguageType.Spanish;
    }
    addSystemInformation(leadBody, flow);
    addAgentInformation(leadBody);
    addCampaignTracking(leadBody);
    leadBody['gclid'] = safeLocalStorageGetItem("gclid") || window.readCookie("gclid");
    leadBody['NAFHubAltPage'] = flow.config.nafHubAltPage || null;
    leadBody['fbclid'] = ((_a = window.urlParamLookup) === null || _a === void 0 ? void 0 : _a.fbclid) || null;
    leadBody['oppref'] = ((_b = window.urlParamLookup) === null || _b === void 0 ? void 0 : _b.oppref) || null;
    var fromCampaignId = readUrlParam("campaignid");
    var fromUtmCampaign = readUrlParam("utm_campaign");
    var campaignId = isGuid(fromCampaignId) ? fromCampaignId : fromUtmCampaign;
    leadBody['CampaignId'] = isGuid(campaignId) ? campaignId : null;
    // US-536041 / Bug 546174: exact /df/home-loans only; LS then cookie then URL (gclid order).
    leadBody['msclkid'] = isMsclkidCapturePath(window.location.pathname)
        ? (safeLocalStorageGetItem("msclkid") || window.readCookie("msclkid") || ((_c = window.urlParamLookup) === null || _c === void 0 ? void 0 : _c.msclkid) || null)
        : null;
    return leadBody;
}
function addSystemInformation(leadBody, flow) {
    leadBody["PostUrl"] = window.location.href || (flow === null || flow === void 0 ? void 0 : flow.flowId) || "";
    leadBody["Refferingurl"] = safeLocalStorageGetItem('PPC_LT_pageurl') || safeLocalStorageGetItem('PPC_FT_pageurl')
        || document.referrer || window.location.href;
    leadBody["PathBeforeFormUrl"] = document.referrer;
    leadBody["Application"] = "Dynamicform_" + flow.config.templateType;
    leadBody["IsMobile"] = isMobile;
    leadBody["Browser"] = browserName;
    leadBody["DeviceType"] = deviceType;
    leadBody["IpAddress"] = safeLocalStorageGetItem("ipAddress") || "";
    leadBody["byPassLPS"] = false;
    leadBody["LeadId"] = crypto.randomUUID();
    leadBody["PathExternalUrl"] = safeLocalStorageGetItem("Path_External_URL") || null;
    leadBody["PathEntranceUrl"] = safeLocalStorageGetItem("Path_Entrance_URL") || null;
}
function addAgentInformation(leadBody) {
    var _a;
    //Refer US506145 - skip FirstVisitToNAF
    // Credit logic based on the users first visit
    //if (safeLocalStorageGetItem("FirstVisitToNAF")) {
    //    // Leave if the user visited NAF or paid campaign first
    //} else {
    if (safeLocalStorageGetItem("agentid") != null) {
        var guid = (_a = safeLocalStorageGetItem("agentid")) === null || _a === void 0 ? void 0 : _a.toString().replace(/["']/g, "");
        if (!safeLocalStorageGetItem("PPC_FT_date")) {
            leadBody["AgentId"] = guid;
            if (safeLocalStorageGetItem("AgentIsILA") === "true") {
                leadBody["AgentIsILA"] = true;
            }
        }
        leadBody["agentGuid"] = guid;
        leadBody["loName"] = safeLocalStorageGetItem("AgentName");
    }
    //}
}
function addCampaignTracking(leadBody) {
    var _a;
    var loan = (_a = leadBody["LoanPurpose"]) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    // Reverse ONLY :: ignore FT/LT and Modify SEO
    if (loan != 'purchase' && loan != 'refinance') {
        if (safeLocalStorageGetItem("PostSeoEntrancePage") != null) {
            leadBody["PriorSeoEntrancePage"] = safeLocalStorageGetItem("PostSeoEntrancePage") || null; // Prior == Post
            leadBody["IsSeoLead"] = true;
        }
        else if (safeLocalStorageGetItem('PriorSeoEntrancePage') != null) {
            leadBody["PriorSeoEntrancePage"] = safeLocalStorageGetItem("PriorSeoEntrancePage") || null; // Prior == Prior
            leadBody["IsSeoLead"] = true;
        }
        else {
            leadBody["IsSeoLead"] = false;
        }
    }
    // Purchase / Refinance ONLY :: include FT/LT (A.K.A. Not Reverse)
    else {
        leadBody["FirstTouch"] = safeLocalStorageGetItem("PPC_FT_" + loan) || null;
        leadBody["LastTouch"] = safeLocalStorageGetItem("PPC_LT_" + loan) || null;
        leadBody["IsSeoLead"] = !safeLocalStorageGetItem("PPC_FT_" + loan) &&
            !!safeLocalStorageGetItem("PriorSeoEntrancePage") &&
            (leadBody.SourceCode != Campaign.TV_Atlanta || (!!safeLocalStorageGetItem("agentid") && safeLocalStorageGetItem("AgentIsILA") != "true"));
        leadBody["PriorSeoEntrancePage"] = safeLocalStorageGetItem("PriorSeoEntrancePage") || null;
        leadBody["PostSeoEntrancePage"] = safeLocalStorageGetItem("PostSeoEntrancePage") || null;
        leadBody["FTPageUrl"] = safeLocalStorageGetItem("PPC_FT_pageurl") || null;
        leadBody["LTPageUrl"] = safeLocalStorageGetItem("PPC_LT_pageurl") || null;
        leadBody["FTPhone"] = safeLocalStorageGetItem("PPC_FT_phone") || null;
        leadBody["LTPhone"] = safeLocalStorageGetItem("PPC_LT_phone") || null;
        // T30 Campaign additional URL Parameters
        addT30CampaignParameters(leadBody);
    }
}
function addT30CampaignParameters(leadBody) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (leadBody["LastTouch"]) {
        leadBody["NRPUID"] = safeLocalStorageGetItem("PPC_LT_nrpuid") || ((_a = window.urlParamLookup) === null || _a === void 0 ? void 0 : _a.nrpuid) || null;
        leadBody["NRFUID"] = safeLocalStorageGetItem("PPC_LT_nrfuid") || ((_b = window.urlParamLookup) === null || _b === void 0 ? void 0 : _b.nrfuid) || null;
        leadBody["RealtorName"] = safeLocalStorageGetItem("PPC_LT_realtorname") || ((_c = window.urlParamLookup) === null || _c === void 0 ? void 0 : _c.realtorname) || null;
        leadBody["Referrername"] = safeLocalStorageGetItem("PPC_LT_referrername") || ((_d = window.urlParamLookup) === null || _d === void 0 ? void 0 : _d.referrername) || null;
    }
    else if (leadBody["FirstTouch"]) {
        leadBody["NRPUID"] = safeLocalStorageGetItem("PPC_FT_nrpuid") || ((_e = window.urlParamLookup) === null || _e === void 0 ? void 0 : _e.nrpuid) || null;
        leadBody["NRFUID"] = safeLocalStorageGetItem("PPC_FT_nrfuid") || ((_f = window.urlParamLookup) === null || _f === void 0 ? void 0 : _f.nrfuid) || null;
        leadBody["RealtorName"] = safeLocalStorageGetItem("PPC_FT_realtorname") || ((_g = window.urlParamLookup) === null || _g === void 0 ? void 0 : _g.realtorname) || null;
        leadBody["Referrername"] = safeLocalStorageGetItem("PPC_FT_referrername") || ((_h = window.urlParamLookup) === null || _h === void 0 ? void 0 : _h.referrername) || null;
    }
}
function handleSuccessfulSubmission(data, leadBody) {
    if (data && data.lpsInquiryId) {
        safeLocalStorageSetItem("leadId", data.lpsInquiryId);
        if (typeof window.leadSubmitHandler === "function") {
            window.leadSubmitHandler();
        }
    }
    removeFromStorage("df");
    if (data && data.redirectUrl && data.redirectUrl.includes("/thank-you-no-service/")) {
        redirectToThankYouPage(leadBody, data.lpsInquiryId, data.redirectUrl);
    }
    else {
        window.location.href = (data && data.redirectUrl) || path.thankYou;
    }
}
function redirectToThankYouPage(requestPayload, lpsInquiryId, redirectUrl) {
    var form = document.createElement("form");
    form.method = "POST";
    form.action = redirectUrl;
    var fields = {
        FirstName: requestPayload.firstName,
        LastName: requestPayload.lastName,
        Email: requestPayload.email,
        Phone: requestPayload.phone,
        Inquiryid: lpsInquiryId
    };
    Object.entries(fields).forEach(function (_a) {
        var name = _a[0], value = _a[1];
        var input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = value;
        form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
}
function parsePropertyAddress(leadBody) {
    var components = leadBody.propertyAddress ? leadBody.propertyAddress.split(",").map(function (part) { return part.trim(); }) : [];
    if (components.length < 3)
        return;
    var parts = {
        AddressLineText: components[0],
        City: components[1],
        State: components[2].split(" ")[0],
        Zipcode: components[2].split(" ")[1]
    };
    return parts;
}
